/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_Transfer_Recipient_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Select who takes over" |
*
* @param {Member_Transfer_Recipient_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_transfer_recipient_placeholder = /** @type {((inputs?: Member_Transfer_Recipient_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Transfer_Recipient_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Übernehmendes Mitglied auswählen")
	return /** @type {LocalizedString} */ ("Select who takes over")
});